/* Menu panels on demand (mobile audit P1.2, 2026-09-22).

   Every page used to carry both menus in full: the desktop dropdowns
   (sections/newbrand-megamenu.liquid, ~157k chars, 71 images) and the phone
   drawer's brand panes (sections/newbrand-menu.liquid, ~98k chars, 69 images),
   and brand pages carry each twice. Now the page HTML has the bar, the nav
   words, the drawer's rail and every control; the heavy panels are left out and
   fetched here from the same section through the Section Rendering API
   (`<this path>?section_id=<id>`). That render has no `section.index`, so the
   section prints its panels exactly as the page used to, with this page's own
   settings (brand pages included).

   - Only what the device can open is fetched: the drawer when its Menu button
     is on screen (the bottom bar, up to 989px), the dropdowns when the nav words
     are (900px up). Crossing a breakpoint (rotation, resize) fetches the other.
   - When: on idle after load (or after the first touch/scroll/key, if that
     comes sooner), at low fetch priority; and at once, at high priority, on the
     first sign of intent (a touch or focus on the Menu button, the pointer
     reaching a nav word).
   - Except the desktop dropdowns (2026-09-25, Guneet: "the menu dropdowns take a
     while to start working"): they are fetched as soon as this file runs, at
     normal priority. Waiting for load, then queueing behind the page's images at
     low priority, left the nav words dead for 2.6-5s on live; the panels are
     ~29 KB, which a desktop can spare. The phone drawer keeps the idle rule.
   - The drawer's open waits for its panes (sections/newbrand-menu.liquid), so
     it never slides in empty; a dropdown is not shown until its panel is in.
   - The markup moved in is exactly the server's, in the same place (panes go
     in front of the scroll track newbrand-rail.js appended), and the rail
     script is asked to pick up the new scrollers. Every control (radios,
     labels, arrows, hover tabs, dialog/focus handling) is delegated or bound to
     elements that were already in the page, so nothing needs re-binding.
   - A failed fetch is retried twice (the second retry from the home page for
     the header copy, as JSON for a brand page's own copy). If all three fail,
     a waiting drawer opens anyway (bar and rail, no panes) rather than leave
     the button dead, and the next open tries again. */
(function () {
  if (window.__nbMenuLazy) return;

  var reg = {};
  var list = [];
  var idle = false;
  var stats = window.__nbLazyStats = {};

  function el(id) { return document.getElementById('nb-' + id); }
  function drawn(n) { return !!(n && n.getClientRects().length); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function now() { return window.performance && performance.now ? performance.now() : Date.now(); }
  function mq(q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; }
  var mqPhone = mq('(max-width: 989px)');   // the bottom bar with the Menu button
  var mqDesk = mq('(min-width: 900px)');    // the header nav words

  function register(o) {
    if (!o || !o.id || reg[o.id]) return;
    var r = { id: o.id, kind: o.kind, trigger: o.trigger || '', done: false, p: null };
    reg[o.id] = r;
    list.push(r);
    if (r.kind === 'mega' && needed(r)) load(r.id, 'auto').catch(function () {});
    else if (idle) prefetch();
  }

  function needed(r) {
    var root = el(r.id);
    if (!drawn(root)) return false;             // e.g. the header copy on brand pages
    if (r.kind === 'mega') return mqDesk.matches && drawn(root.querySelector('.nb-nav'));
    var t = r.trigger ? document.querySelector(r.trigger) : null;
    if (t) return drawn(t) && getComputedStyle(t).visibility !== 'hidden';
    return mqPhone.matches;
  }

  // Tries 0 and 1: this page, as HTML. Try 2: a header-group copy (the same
  // on every page) from the home page; a template copy (brand pages) as JSON.
  function url(id, n) {
    if (n >= 2 && /^sections--/.test(id)) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return root + '?section_id=' + encodeURIComponent(id);
    }
    var q = location.search ? location.search + '&' : '?';
    return location.pathname + q + (n >= 2 ? 'sections=' : 'section_id=') + encodeURIComponent(id);
  }

  function parse(txt, id, json) {
    if (json) { txt = JSON.parse(txt)[id]; if (!txt) throw new Error('empty'); }
    var t = document.createElement('template');
    t.innerHTML = txt;
    var src = t.content.getElementById ? t.content.getElementById('nb-' + id) : t.content.querySelector('[id="nb-' + id + '"]');
    if (!src) throw new Error('no section');
    return src;
  }

  function moveKids(from, to, before) {
    var frag = document.createDocumentFragment();
    while (from.firstChild) frag.appendChild(from.firstChild);
    to.insertBefore(frag, before || null);
  }

  function fill(r, src) {
    var root = el(r.id);
    if (!root) throw new Error('gone');
    if (r.kind === 'menu') {
      var from = src.querySelector('.nb-panes'), to = root.querySelector('.nb-panes');
      if (!from || !to || !from.querySelector('.nb-pane')) throw new Error('no panes');
      if (!to.querySelector('.nb-pane')) moveKids(from, to, to.firstChild);
    } else {
      var tos = root.querySelectorAll('.nb-navgrp > .nb-mega');
      var froms = src.querySelectorAll('.nb-navgrp > .nb-mega');
      if (!froms.length) throw new Error('no panels');
      for (var i = 0; i < tos.length && i < froms.length; i++) {
        var m = tos[i];
        if (m.querySelector('.nb-mpanes, .nb-ev1')) continue;
        while (m.firstChild) m.removeChild(m.firstChild);   // the <noscript> links
        moveKids(froms[i], m);
      }
      var hold = document.getElementById('nb-lazywait-' + r.id);   // added by the section
      if (hold) hold.parentNode.removeChild(hold);
    }
    if (window.__nbScanScrollbars) window.__nbScanScrollbars();
  }

  function attempt(r, n, hi) {
    var json = n >= 2 && !/^sections--/.test(r.id);
    var s = stats[r.id] = stats[r.id] || { kind: r.kind, tries: 0 };
    s.tries++;
    s.start = s.start || now();
    return fetch(url(r.id, n), { credentials: 'same-origin', priority: hi === true ? 'high' : (hi || 'low') })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
      .then(function (txt) {
        s.fetched = now();
        fill(r, parse(txt, r.id, json));
        s.filled = now();
      });
  }

  function load(id, hi) {
    var r = reg[id];
    if (!r) return Promise.reject(new Error('unknown'));
    if (r.done) return Promise.resolve();
    if (!r.p) {
      r.p = attempt(r, 0, hi)
        .catch(function () { return wait(600).then(function () { return attempt(r, 1, true); }); })
        .catch(function () { return wait(1200).then(function () { return attempt(r, 2, true); }); })
        .then(function () { r.done = true; }, function (e) { r.p = null; throw e; });
    }
    return r.p;
  }

  // For an open that is waiting: once the panes are in, give the brand logos
  // (the only eager images in them) a moment to arrive, never more than 300ms.
  function settle(id) {
    var root = el(id);
    var imgs = root ? [].filter.call(root.querySelectorAll('.nb-panes img'), function (i) {
      return !i.complete && i.getAttribute('loading') !== 'lazy';
    }) : [];
    if (!imgs.length) return Promise.resolve();
    return Promise.race([
      Promise.all(imgs.map(function (i) {
        return new Promise(function (res) {
          i.addEventListener('load', res, { once: true });
          i.addEventListener('error', res, { once: true });
        });
      })),
      wait(300)
    ]);
  }

  function prefetch() {
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (!r.done && !r.p && needed(r)) load(r.id).catch(function () {});
    }
  }

  // ---- intent ----
  function menuIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (r.kind !== 'menu' || r.done || r.p || !r.trigger) continue;
      if (t.closest(r.trigger) && drawn(el(r.id))) load(r.id, true).catch(function () {});
    }
  }
  function megaIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var nav = t.closest('.nb-nav');
    if (!nav) return;
    var root = nav.closest('[data-nb-root]');
    var r = root && root.id ? reg[root.id.slice(3)] : null;
    if (r && r.kind === 'mega' && !r.done && !r.p) load(r.id, true).catch(function () {});
  }
  document.addEventListener('pointerdown', menuIntent, true);
  document.addEventListener('touchstart', menuIntent, { capture: true, passive: true });
  document.addEventListener('focusin', menuIntent, true);
  document.addEventListener('pointerover', megaIntent, true);
  document.addEventListener('focusin', megaIntent, true);

  // ---- breakpoint crossings ----
  function onChange() { if (idle) prefetch(); }
  [mqPhone, mqDesk].forEach(function (m) {
    if (m.addEventListener) m.addEventListener('change', onChange);
    else if (m.addListener) m.addListener(onChange);
  });
  var rt = 0;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(onChange, 250); });

  // ---- idle after load ----
  // Also started by the shopper's first touch, scroll or key before load has
  // fired (on a slow phone the load event can be seconds away), since the
  // Menu button is often the next thing touched.
  var started = false;
  function start() {
    if (started) return;
    started = true;
    var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
    ric(function () { idle = true; prefetch(); }, { timeout: 2000 });
  }
  if (document.readyState === 'complete') start();
  else {
    window.addEventListener('load', start);
    ['touchstart', 'pointerdown', 'keydown', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, start, { capture: true, passive: true, once: true });
    });
    setTimeout(start, 6000);   // a page whose load event never settles
  }

  window.__nbMenuLazy = {
    ready: function (id) { var r = reg[id]; return !!(r && r.done); },
    load: function (id, forOpen) {
      var p = load(id, true);
      return forOpen ? p.then(function () { return settle(id); }) : p;
    }
  };

  // queued by the section scripts that ran before this file
  var q = window.__nbLazyQ;
  window.__nbLazyQ = { push: register };
  if (q && q.length) for (var i = 0; i < q.length; i++) register(q[i]);
  var w = window.__nbLazyWait;
  window.__nbLazyWait = {
    push: function (a) { window.__nbMenuLazy.load(a[0], true).then(a[1], a[1]); }
  };
  if (w && w.length) for (var j = 0; j < w.length; j++) window.__nbLazyWait.push(w[j]);
})();
